(function () {
  let loading = false;
  let currentPage = 1;
  let totalPages = null;
  let ticking = false;

  function init() {
    // Mode Depict : les balises invisibles exposent juste la pagination
    // (page actuelle / nombre de pages), Depict ne fait pas le scroll
    // infini lui-même.
    const beacon = document.querySelector('depict-grid-start-beacon');
    if (beacon) {
      try {
        const data = JSON.parse(beacon.dataset.paginate);
        currentPage = data.current_page + 1; // 0-indexed côté Depict
        totalPages = data.pages;
      } catch (e) {
        return;
      }
    } else {
      // Mode Shopify natif — lire le lien "page suivante"
      const nextLink = document.querySelector('a[href*="page="]');
      if (!nextLink) return; // une seule page, rien à faire
      const url = new URL(nextLink.href);
      currentPage = parseInt(url.searchParams.get('page')) - 1;
      totalPages = getLastPage();
    }

    if (!totalPages || totalPages <= 1) return;

    // Cacher la pagination native
    const pagination = document.querySelector('.pagination, nav[aria-label*="pagination" i]');
    if (pagination) pagination.style.display = 'none';

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function getLastPage() {
    const links = document.querySelectorAll('a[href*="page="]');
    let max = 1;
    links.forEach((link) => {
      const url = new URL(link.href);
      const p = parseInt(url.searchParams.get('page'));
      if (p > max) max = p;
    });
    return max;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      maybeLoadNextPage();
      ticking = false;
    });
  }

  function maybeLoadNextPage() {
    if (loading || currentPage >= totalPages) return;

    const grid = document.querySelector('ul.collection-list');
    if (!grid) return;

    const rect = grid.getBoundingClientRect();
    if (rect.bottom < window.innerHeight + 400) {
      loadNextPage();
    }
  }

  async function loadNextPage() {
    const grid = document.querySelector('ul.collection-list');
    if (!grid) return;

    loading = true;
    currentPage++;

    // On récupère uniquement le fragment de la section (comme le fait déjà
    // filterable.js pour les filtres) plutôt que la page HTML complète :
    // beaucoup plus léger et rapide, surtout sur mobile.
    let sectionId = 'main';
    try {
      sectionId = getSectionId(grid);
    } catch (e) {
      // pas de .shopify-section parent trouvé : on garde le fallback 'main'
    }

    const url = getURLAddingParams(window.location.href, {
      page: currentPage,
      section_id: sectionId,
    });

    try {
      const html = await freshHTML(url.toString());
      const newGrid = querySelectorInHTMLString('ul.collection-list', html);

      if (!newGrid) throw new Error('Grille introuvable dans la page suivante');

      const endBeacon = grid.querySelector('depict-grid-end-beacon');

      // Le "remplissage" de fin de rangée (li[aria-hidden]) n'est correct
      // que pour la page qui s'avère être la toute dernière : on retire
      // l'ancien avant d'ajouter la suite, sinon il reste coincé au milieu
      // de la grille et laisse un espace blanc visible en bas de page.
      grid
        .querySelectorAll(':scope > li[aria-hidden="true"]')
        .forEach((el) => el.remove());

      newGrid.querySelectorAll(':scope > li').forEach((item) => {
        const node = item.cloneNode(true);
        if (endBeacon) {
          grid.insertBefore(node, endBeacon);
        } else {
          grid.appendChild(node);
        }
      });

      // Permet à un script tiers (ex. Depict) qui surveillerait la grille
      // de savoir que de nouvelles cartes viennent d'être ajoutées.
      document.dispatchEvent(
        new CustomEvent('collection:grid-updated', {
          detail: { page: currentPage },
        })
      );

      if (currentPage >= totalPages) {
        window.removeEventListener('scroll', onScroll);
      }
    } catch (e) {
      currentPage--;
    } finally {
      loading = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
